import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, toggle, pdfManager,
    FetchData, Helpers,

    defaultData,

    //------------- Forms
    Forms,

    globalStates

}) => {

    const { convertToFloat, drawPaymentTicket } = Helpers

    // Estado para bloquear botones mientras una operación al backend está en curso
    const [pending, setPending] = useState({})

    const withPending = (key, fn) => async (...args) => {
        if (pending[key]) return
        setPending(p => ({ ...p, [key]: true }))
        try {
            return await fn(...args)
        } finally {
            setPending(p => ({ ...p, [key]: false }))
        }
    }

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const closeModal = () => {
        toggle()
    }

    const handleClickShowForm = (openingMode, contractLoaded) => {
        const { 
            setShowForm, 
            setFormOpeningMode,
            setContractLoaded,
        } = globalStates

        setFormOpeningMode(openingMode)
        setContractLoaded((contractLoaded === 1)) 
        setShowForm(true)
    }

    const handleClickHideForm = () => {
        const {
            setShowForm,
            setStepApplilication,
            setShowSection,
            setImagesCurrentIndex,
            setShowModalDeposit,
            setModalOpeningMode,
            setFormOpeningMode,
            setshowTypeForm,
        } = globalStates;

        const { fetchAllCreditsApplication: { executeFetchAllCreditsApplications } } = FetchData;

        //Refresca listado principal
        executeFetchAllCreditsApplications();

        // Resetea formularios (esto evita que “quede algo abierto”)
        Forms?.FormRequestGlobal?.onResetForm?.();
        Forms?.FormCollateral?.onResetForm?.();
        Forms?.FormDeposit?.onResetForm?.();

        // Resetea sección de garantías/imágenes
        setShowSection('HOME');
        setImagesCurrentIndex(0);

        // Cierra/Resetea modales y modos
        setShowModalDeposit(false);
        setModalOpeningMode('EDITABLE');
        setFormOpeningMode('EDITABLE');
        setshowTypeForm('None');

        // Resetea stepper y cierra formulario principal
        setStepApplilication(0);
        setShowForm(false);
    };

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication } = globalStates
        setStepApplilication(stepApplilication - 1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication } = globalStates
        setStepApplilication(stepApplilication + 1)
    }

    const handleClickImage = () => {
        const { setShowSection } = globalStates
        setShowSection('IMAGE')
    }

    const handleClickCloseImage = () => {
        const { setShowSection, setImagesCurrentIndex } = globalStates
        const { FormCollateral: { onResetForm } } = Forms

        onResetForm()
        setShowSection('HOME')
        setImagesCurrentIndex(0)
    }

    const handleClickDeleteCollateralImage = (idimagen) => {
        const { FormCollateral: { formState } } = Forms
        const { fetchCollateralImages: { executeFetchCollateralImages } } = FetchData
        const idcollateral = formState.idcollateral;

        Swal.fire({
            title: '¿Desea eliminar esta imagen?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(withPending('deleteCollateralImage', async (result) => {
            if (!result.isConfirmed) return
            await marvarApi.delete(`/credits/collateral/${idcollateral}/images/${idimagen}`)
                .then(({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') executeFetchCollateralImages()
                })
                .catch(err => console.log('API ERROR:', err))
        }))
    }

    const handleClickShowCollateralImages = async (idcollateral) => {
        const { FormCollateral: { setFormState } } = Forms;
        const { setShowSection, setImagesCurrentIndex } = globalStates;

        setImagesCurrentIndex(0);

        setFormState(prev => ({
            ...prev,
            idcollateral,
            images: []
        }));
        setShowSection('IMAGE')
    }

    const handleNextCollateralImage = () => {
        const { FormCollateral: { formState } } = Forms
        const images = formState.images
        const { setImagesCurrentIndex, imagesCurrentIndex } = globalStates

        setImagesCurrentIndex((prevIndex) =>
            prevIndex + 1 < images.length ? prevIndex + 1 : 0
        );
    }

    const handlePreviousCollateralImage = () => {
        const { FormCollateral: { formState } } = Forms
        const images = formState.images
        const { setImagesCurrentIndex, imagesCurrentIndex } = globalStates

        setImagesCurrentIndex((prevIndex) =>
            prevIndex - 1 >= 0 ? prevIndex - 1 : images.length - 1
        );
    }


    const handleClickCleanUpCollateralImagesFiles = () => {
        const { FormCollateral: { setFormState } } = Forms

        setFormState(prev => ({
            ...prev,
            fileRejections: [],
            acceptedFiles: [],
            // opcional: fuerza reset visual del FileManagerInput si se queda pegado
            dropzoneKey: (prev.dropzoneKey || 0) + 1,
        }))
    }

    //     const handleClickDeleteDocument = (iddocumento) => {

    //         const { fetchAllFiles } = FetchData
    //         const { executeFetchAllFiles } = fetchAllFiles
    //         Swal.fire({
    //             title: '¿Desea eliminar este registro?',
    //             showConfirmButton: true,
    //             showCancelButton: true,
    //             confirmButtonText: 'Eliminar',
    //             cancelButtonText: 'Cancelar'
    //         }).then(async result => {
    //             if (result.isConfirmed) {
    //                 await marvarApi.delete(`/leases/common/delete-document/${iddocumento}`)
    //                 .then( ({ data }) => {
    //                     alertMessage(data)
    //                     if (data.title === 'OK') {
    //                         executeFetchAllFiles()
    //                         // closeModal()
    //                         }else{

    //                         }
    //                 }).catch(error => {
    //                     console.log('API ERROR: ', error)
    //                 })
    //             }
    //         })
    //     }

    //     const handleClickDeleteDeposit = (iddocumento) => {

    //         const { fetchAllDeposits } = FetchData
    //         const { executeFetchAllDeposits } = fetchAllDeposits
    //         Swal.fire({
    //             title: '¿Desea eliminar este registro?',
    //             showConfirmButton: true,
    //             showCancelButton: true,
    //             confirmButtonText: 'Eliminar',
    //             cancelButtonText: 'Cancelar'
    //         }).then(async result => {
    //             if (result.isConfirmed) {
    //                 await marvarApi.delete(`/leases/management/delete-deposit/${iddocumento}`)
    //                 .then( ({ data }) => {
    //                     alertMessage(data)
    //                     if (data.title === 'OK') {
    //                         executeFetchAllDeposits()
    //                         // closeModal()
    //                         }else{

    //                         }
    //                 }).catch(error => {
    //                     console.log('API ERROR: ', error)
    //                 })
    //             }
    //         })
    //     }

    //     const handleChangeTotalMonths = ({ target }) => {
    //         // console.log(event);
    //         const { FormLeases } = Forms
    //         const { formState ,setFormState } = FormLeases

    //         // const data = JSON.parse(event.target.value || null)

    //         const { name, value } = target;
    //         setFormState({
    //             ...formState,
    //             [ name ]: value,
    //             contrato_total_alquiler: (formState.contrato_costo_alquiler * (value || 0))
    //         });
    //     }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto, deposito_tipo_cambio } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;


        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (clean_deposito_monto / tipo_cambio)
            }))
        }
    }


    const onSubmitFormApplies = withPending('submitApplies', async (e) => {

        e.preventDefault()

        const { getCurrentDate, isDayThirtyOne } = Helpers

        //HOOKS
        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal

        const { formOpeningMode } = globalStates

        //Validaciones generales
        if (formState.idcliente == 0) {
            const messageCustom = {
                message: 'Debe seleccionar un cliente',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        if (formState.idcotizacion == 0) {
            const messageCustom = {
                message: 'Debe seleccionar una cotizacion',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        if (isDayThirtyOne(formState.credito_dia_pago)) {
            const messageCustom = {
                message: 'El dia 31 no puede ser asiganado como dia de pago',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        if (formState.idgestion_refinanciamiento > 0 && formState.credito_dia_pago < getCurrentDate()) {
            alertMessage({ message: 'La fecha de pago no puede ser una fecha pasada', title: 'FAIL', rows: [] })
            return
        }

        if (!formState.idorigen || formState.idorigen === '') {
            alertMessage({ message: 'Debe seleccionar un origen financiero', title: 'FAIL', rows: [] })
            return
        }

        let _data = {
            idcotizacion: formState.idcotizacion,
            idcliente: formState.idcliente,
            idorigen: formState.idorigen,
            credito_fecha: formState.credito_fecha,
            credito_dia_pago: formState.credito_dia_pago,
            costo_papeleria: formState.clean_costo_papeleria || 0
        }

        if (formState.idcredito > 0) {

            if (formOpeningMode === 'EDITABLE') {

                _data['usuario_modifico'] = user.username
                _data['fecha_modifico'] = getCurrentDate()

                await marvarApi.put(`/credits/mgmt-managements/${formState.idcredito}`, _data)
                    .then(({ data }) => {

                        alertMessage(data)

                        if (data.title === 'OK') {
                            handleClickNextStep()
                        }

                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })

            } else {
                handleClickNextStep()
            }

        } else {

            _data['usuario_creo'] = user.username
            _data['fecha_creo'] = getCurrentDate()

            await marvarApi.post(`/credits/mgmt-managements`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        setFormState((prevState) => ({
                            ...prevState,
                            idcredito: data.insertId,
                        }))
                        handleClickNextStep()     // ✅ POST OK
                    }

                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
        }
    })

    const onSendLogs = withPending('sendLogs', async (e) => {


        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal

        const { fetchInfoObservations: { executeFetchAllObservations } } = FetchData


        const { getCurrentDate } = Helpers

        await marvarApi.post(`/credits/common/log-vehicle/${formState.idcredito}`, {
            idusuario: user.uid,
            log_fecha: getCurrentDate(),
            log_observacion: formState.aprobacion_observaciones,
            log_departamento: "Gestor"
        })
            .then(({ data }) => {
                alertMessage(data)
                if (data.title === 'OK') {
                    setFormState((prevState) => ({
                        ...prevState,
                        aprobacion_observaciones: ''
                    }))
                    executeFetchAllObservations()
                }
            })

    })

    const onSubmitFormFiles = withPending('submitFiles', async (e) => {

        e.preventDefault()

        const { FormRequestGlobal: { formState, setFormState } } = Forms
        const { getCurrentDate } = Helpers


        const { fetchAllFiles } = FetchData
        const { executeFetchAllFiles } = fetchAllFiles



        if (formState.acceptedFiles.length <= 0) {
            const messageCustom = {
                message: 'No se ha cargado nigun archivo',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        const _data = new FormData();

        _data.append('idcredito', formState.idcredito);
        _data.append('department', 'GESTOR');
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', getCurrentDate());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if (formState.idcredito > 0) {

            await marvarApi.post(`/credits/common/create-document`, _data)
                .then(({ data }) => {

                    if (data.title === 'OK') {
                        setFormState(prevState => ({
                            ...prevState,
                            acceptedFiles: [],
                            fileRejections: []
                        }))
                        executeFetchAllFiles()
                    }
                    alertMessage(data)
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    })

    const handleClickDeleteDocument = (iddocumento) => {

        const { fetchAllFiles } = FetchData
        const { executeFetchAllFiles } = fetchAllFiles
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(withPending('deleteDocument', async result => {
            if (!result.isConfirmed) return
            await marvarApi.delete(`/credits/common/delete-document/${iddocumento}`)
                .then(({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllFiles()
                        // closeModal()
                    } else {

                    }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
        }))
    }


    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const { setModalOpeningMode } = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {

        //HOOKS
        const { FormDeposit, FormCollateral } = Forms
        const { onResetForm } = FormDeposit
        const onResetFormCollateral = FormCollateral.onResetForm
        onResetForm()
        onResetFormCollateral()
        closeModal()
    }

    const onSubmitFormDeposits = withPending('submitDeposit', async (e) => {

        e.preventDefault()

        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateGlobal = FormRequestGlobal.formState

        const { fetchAllDeposits: { executeFetchAllDeposits } } = FetchData

        const { getCurrentDate } = Helpers


        if (formState.movimiento_tipo === 'EFECTIVO') {

            const _data = {
                idcredito: formStateGlobal.idcredito,
                deposito_usuario: user.username,
                deposito_fecha: formState.deposito_fecha,
                movimiento_tipo: formState.movimiento_tipo,
                deposito_monto: formState.clean_deposito_monto,
                deposito_moneda: formState.deposito_moneda,
                deposito_tipo_cambio: formState.deposito_tipo_cambio,
                deposito_quetzal: formState.clean_deposito_quetzales,
                deposito_dolares: formState.clean_deposito_dolares,
                idcaja: formState.idcaja,
                deposito_observaciones: formState.deposito_observaciones,
                usuario_creo: user.username,
                fecha_creo: getCurrentDate()
            }

            await marvarApi.post(`/credits/common/create-deposit-cash`, _data)
                .then(async ({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        onResetForm()
                        executeFetchAllDeposits()
                        closeModal()
                        await handleClickDownloadTicket(data.insertId)

                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }

        if (formState.movimiento_tipo === 'DEPOSITO') {

            if (formState.acceptedFiles.length <= 0) {

                const messageCustom = {
                    message: 'Debe cargar el comprobante para poder registrar el deposito',
                    title: 'FAIL',
                    rows: []
                }

                alertMessage(messageCustom)

                return
            }

            const _data = new FormData();

            _data.append('idcredito', formStateGlobal.idcredito)
            _data.append('idbanco', formState.idbanco)
            _data.append('movimiento_tipo', formState.movimiento_tipo)
            _data.append('deposito_fecha', formState.deposito_fecha)
            _data.append('deposito_usuario', user.username)
            _data.append('deposito_monto', formState.clean_deposito_monto)
            _data.append('deposito_moneda', formState.deposito_moneda)
            _data.append('deposito_tipo_cambio', formState.deposito_tipo_cambio)
            _data.append('deposito_quetzal', formState.clean_deposito_quetzales)
            _data.append('deposito_dolares', formState.clean_deposito_dolares)
            _data.append('boleta_numero', formState.boleta_numero)
            _data.append('usuario_creo', user.username)
            _data.append('fecha_creo', getCurrentDate())

            formState.acceptedFiles.forEach((file, index) => {
                _data.append(`images`, file);
            });

            await marvarApi.post(`/credits/common/create-deposit-bank`, _data)
                .then(async ({ data }) => {
                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllDeposits()
                        onResetForm()
                        closeModal()
                        await handleClickDownloadTicket(data.insertId)

                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    })

    const handleChangeAmount = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState, onInputChangeForNumber } = FormDeposit
        const { deposito_tipo_cambio } = formState

        const { value } = event.target

        onInputChangeForNumber(event)
        const clean_value = convertToFloat(value)

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? parseFloat(deposito_tipo_cambio) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_value),
                clean_deposito_quetzales: (clean_value * tipo_cambio),
                clean_deposito_dolares: clean_value
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value),
                deposito_dolares: numberFormatter.format(clean_value / tipo_cambio),
                clean_deposito_quetzales: clean_value,
                clean_deposito_dolares: (clean_value / tipo_cambio)
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        // const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = value !== '' ? parseFloat(value) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: (tipo_cambio === 0) ? 0 : numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (tipo_cambio === 0) ? 0 : (clean_deposito_monto / tipo_cambio)
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const handleClickFetchInfoDeposit = async (iddeposit) => {

        const { FormDeposit: { onResetForm } } = Forms


        const { fetchInfoDeposit } = FetchData
        const { setParamsToSearch, executeFetchInfoDeposit } = fetchInfoDeposit

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ iddeposit: iddeposit })
        executeFetchInfoDeposit()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }

    const handleClickDownloadImage = withPending('downloadImage', async (customFileName, openUrl) => {

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();

            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);

            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();

            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);

            toast.success('Se ha descargado la imagen');

        } catch (error) {
            console.error('Error al descargar la imagen', error);
        }

    })

    const handleClickDeleteDeposit = (iddeposit) => {

        const { fetchAllDeposits } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(withPending('deleteDeposit', async result => {
            if (!result.isConfirmed) return
            await marvarApi.delete(`/credits/common/delete-deposit/${iddeposit}`)
                .then(({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllDeposits()
                    } else {

                    }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
        }))
    }

    const onSubmitFormCollateral = withPending('submitCollateral', async (e) => {

        e.preventDefault()

        const { getCurrentDate } = Helpers

        //HOOKS
        const { FormCollateral: { formState }, FormRequestGlobal } = Forms
        const formStateGlobal = FormRequestGlobal.formState

        const { modalOpeningMode } = globalStates

        const { fetchAllCollateral: { executeFetchCollateral } } = FetchData

        //Validaciones generales
        if (formState.type_collateral === '') {
            const messageCustom = {
                message: 'Debe seleccionar un tipo de garantia',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        let _data = {
            idcredito: formStateGlobal.idcredito,
            title: formState.title,
            type_collateral: formState.type_collateral,
            estate: formState.estate,
            folio: formState.folio,
            department: formState.department,
            book: formState.book,
            description: formState.description,
            valor: formState.clean_valor,
            marca: formState.marca,
            modelo: formState.modelo,
            linea: formState.linea,
            color: formState.color,
            matricula: formState.matricula,
            chasis: formState.chasis,
        }


        if (formState.idcollateral > 0) {

            if (modalOpeningMode === 'EDITABLE') {

                _data['usuario_modifico'] = user.username;
                _data['fecha_modifico'] = getCurrentDate();

                await marvarApi.put(`/credits/mgmt-managements/collateral/${formState.idcollateral}`, _data)
                    .then(({ data }) => {

                        alertMessage(data)

                        if (data.title === 'OK') {
                            executeFetchCollateral()
                            handleClickCloseModal()
                        }

                    }).catch(error => { console.log('API ERROR: ', error) })
            } else {
                handleClickCloseModal()
            }

        } else {

            _data['usuario_creo'] = user.username;
            _data['fecha_creo'] = getCurrentDate();

            await marvarApi.post(`/credits/mgmt-managements/collateral`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchCollateral()
                        handleClickCloseModal()
                    }

                }).catch(error => { console.log('API ERROR: ', error) })
        }

    })

    const onSubmitCollateralImages = withPending('submitCollateralImages', async (e) => {
        e.preventDefault()

        const { getCurrentDate } = Helpers
        const { FormCollateral: { formState, setFormState } } = Forms
        const { fetchCollateralImages: { executeFetchCollateralImages } } = FetchData

        if (formState.idcollateral <= 0) {
            alertMessage({ title: 'FAIL', message: 'No hay garantía seleccionada', rows: [] })
            return
        }

        if (!formState.acceptedFiles || formState.acceptedFiles.length <= 0) {
            alertMessage({ title: 'FAIL', message: 'No se ha cargado ninguna imagen', rows: [] })
            return
        }

        const _data = new FormData()
        _data.append('usuario_creo', user.username)
        _data.append('fecha_creo', getCurrentDate())

        // depende de tu backend: puede ser "images" o "attachmentt"
        formState.acceptedFiles.forEach((file) => {
            _data.append('images', file)
        })

        await marvarApi.post(`/credits/collateral/${formState.idcollateral}/images`, _data)
            .then(({ data }) => {
                alertMessage(data)
                if (data.title === 'OK') {
                    setFormState(prev => ({
                        ...prev,
                        acceptedFiles: [],
                        fileRejections: []
                    }))
                    executeFetchCollateralImages()
                }
            })
            .catch(err => console.log('API ERROR:', err))
    })



    const handleClickFetchInfoCollateral = async (idcollateral, modeOpening) => {

        const { FormCollateral: { onResetForm, setFormState } } = Forms

        const { fetchInfoCollateral: { setParamsToSearch, executeFetchCollateral } } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idcollateral: idcollateral })
        executeFetchCollateral()

        setFormState(prevState => ({
            ...prevState,
            idcollateral: idcollateral
        }))


        handleClickShowModal('', 'Formulario de Garantias', 'collateral-section', {}, modeOpening)

    }

    const handleClickDeleteCollateral = (idcollateral) => {

        const { fetchAllCollateral: { executeFetchCollateral } } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(withPending('deleteCollateral', async result => {
            if (!result.isConfirmed) return
            await marvarApi.delete(`/credits/mgmt-managements/delete-collateral/${idcollateral}`)
                .then(({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchCollateral()
                    } else {

                    }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
        }))
    }

    const handleClickFetchInfoApplication = async (idcredito, idcotizacion, modeOpening, contractLoaded) => {

        const { FormRequestGlobal: { onResetForm, setFormState } } = Forms

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito,
            idcotizacion: idcotizacion,
        }))
        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm(modeOpening, contractLoaded)

    }

    const handleClickDeleteApplication = (idcredito) => {

        const { fetchAllCreditsApplication: { executeFetchAllCreditsApplications } } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
            text: 'Esta acción eliminara toda la informacion relacionada con esta solicitud. Esta accion no se puede deshacer'
        }).then(withPending('deleteApplication', async result => {
            if (!result.isConfirmed) return
            await marvarApi.delete(`/credits/mgmt-managements/${idcredito}`)
                .then(({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllCreditsApplications()
                    }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
        }))
    }

    const handleClickApproval = async () => {
        //HOOKS
        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal
        const { getCurrentDate, isDayThirtyOne } = Helpers

        // Solicitud de refinanciamiento: la fecha pudo quedar en el pasado desde que se genero
        if (formState.idgestion_refinanciamiento > 0 &&
            (formState.credito_dia_pago < getCurrentDate() || isDayThirtyOne(formState.credito_dia_pago))) {
            alertMessage({ message: 'La fecha de pago no es valida (fecha pasada o dia 31). Actualicela en el paso de Solicitud antes de enviar', title: 'FAIL', rows: [] })
            return
        }

        Swal.fire({
            title: '¿Está seguro de enviar la solicitud?',
            text: 'Una vez enviada, no podrá editar la información.',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar'
        }).then(withPending('approval', async result => {
            if (!result.isConfirmed) return
            if (formState.aprobacion_check === 'Devuelto a Gestor') {
                await marvarApi.put(`/credits/legal-managements/aprobacion-check/${formState.idcredito}`, { aprobacion_check: 'Pendiente Aprobacion', aprobacion_usuario: user.username, aprobacion_fecha: getCurrentDate() })
                    .then(({ data }) => {
                        alertMessage(data)
                        handleClickHideForm()
                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            } else {
                await marvarApi.put(`/credits/legal-managements/aprobacion-check/${formState.idcredito}`, { aprobacion_check: 'Pendiente Aprobacion', aprobacion_usuario: user.username, aprobacion_fecha: getCurrentDate() })
                    .then(({ data }) => {
                        alertMessage(data)
                        handleClickHideForm()
                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        }))
    }

    const handleClickDownloadTicket = withPending('downloadTicket', async (idmovimiento) => {
        console.log('handleClickDownloadTicket');
        
        try {
            const response = await marvarApi.get(`/credits/common/get-deposit-by-ID/${idmovimiento}`)
            if (response.data.title === 'OK') {
                const _dataForPDF = {
                    idmovimiento: response.data.data.iddeposit,
                    aprobacion_check: response.data.data.aprobacion_check,
                    datos_cliente: response.data.data.nombre_cliente,
                    movimiento_quetzales: numberFormatter.format(response.data.data.deposito_quetzal),
                    deposito_fecha: response.data.data.deposito_fecha,
                    contrato_codigo: `CRED${response.data.data.idcredito}`,
                    movimiento_tipo: response.data.data.movimiento_tipo,
                    movimiento_monto: numberFormatter.format(response.data.data.deposito_monto),
                    deposito_moneda: response.data.data.deposito_moneda,
                    deposito_tipo_cambio: response.data.data.deposito_tipo_cambio,
                    movimiento_dolares: numberFormatter.format(response.data.data.deposito_dolares),
                    descripcion_caja: response.data.data.nombre_caja,
                    descripcion_banco: response.data.data.nombre_banco,
                    boleta_numero: response.data.data.boleta_numero,
                    aprobacion_referencia_ach: response.data.data.aprobacion_referencia_ach,
                    deposito_observaciones: response.data.data.deposito_observaciones,
                    aprobacion_observaciones: response.data.data.aprobacion_observaciones
                }

                drawPaymentTicket(pdfManager, _dataForPDF)
            }
        } catch (e) {
            console.log('API ERROR: ', e)
        }
    })

    return Object.freeze({
        pending,
        handleClickShowForm,
        handleClickHideForm,
        onSubmitFormApplies,
        onSendLogs,
        handleClickReturnStep,
        handleClickNextStep,
        onSubmitFormFiles,
        handleClickDeleteDocument,
        handleClickShowModal,
        handleClickCloseModal,
        onSubmitFormDeposits,
        handleChangeTypeCurrency,
        handleChangeAmount,
        handleChangeExchangeRate,
        handleClickFetchInfoDeposit,
        handleClickDownloadImage,
        handleClickDeleteDeposit,
        onSubmitFormCollateral,
        handleClickFetchInfoCollateral,
        handleClickDeleteCollateral,
        handleClickFetchInfoApplication,
        handleClickDeleteApplication,
        handleClickApproval,
        handleClickDownloadTicket,
        handleClickImage,
        handleClickCloseImage,
        handleClickShowCollateralImages,
        onSubmitCollateralImages,
        handleClickDeleteCollateralImage,
        handleNextCollateralImage,
        handlePreviousCollateralImage,
        handleClickCleanUpCollateralImagesFiles,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message } = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}